const config = {
  title: 'Geometry Dash Demon Timeline',
  githubUrl: '',
  about: 'A timeline of demons I have beaten and plan to beat.',
  sponsorUrl: 'https://ko-fi.com/gddemontimeline',
}

export default config
